import { inject } from '@angular/core';
import { AppSettingsQuery } from 'chronos-shared';

export const manualModeEditSetupGuard = () => {
  const appSettingsQuery = inject(AppSettingsQuery);

  if (!appSettingsQuery.isWorkCenterModeManual()) {
    return true;
  }

  return appSettingsQuery.setupPhaseSetting();
};
